module.exports = __webpack_public_path__ + "img/vip3.bf17e480.png";